/**
 * TRAILER BUILD PLANS™ — purchase configuration.
 *
 * CHECKOUT_URL is the single destination used by every purchase button
 * (offer CTA, final CTA and mobile sticky bar).
 */
export const CHECKOUT_URL = 'https://trailer-build-plans.impultienda.ar/checkout'

export const PRICE = {
  value: 47,
  currency: 'USD',
  label: 'US$47',
  original: 'US$94',
  note: 'One-time payment. Digital PDF collection.',
} as const
